export const BrandMark = ({ size = 32, className = "" }) => (
  <img
    src="/brand-mark.png"
    alt="Ikavio"
    width={size}
    height={size}
    className={`select-none ${className}`}
    draggable={false}
  />
);
